<div class="tw-bg-yellow-100 tw-w-full tw-h-full tw-flex tw-flex-col tw-overflow-hidden tw-relative tw-font-body">
  @if (loading || !imagesReady) {
    <loading class="tw-inline-flex tw-z-10 tw-fixed tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"></loading>
  }

  <!-- Header + FACE/HAIR tabs -->
  <div class="tw-w-full tw-flex-initial tw-bg-black tw-z-[100]">
    <div class="tw-h-14 tw-px-6 tw-flex tw-items-center tw-w-full tw-justify-center tw-relative">
      <div class="tw-absolute tw-left-4 tw-flex tw-items-center tw-justify-center tw-h-10 tw-w-10" (click)="back()">
        <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
      </div>
      @if (userFirstName) {
        <span class="tw-font-bold tw-text-300 tw-text-white tw-normal-case">{{ userFirstName }}<span i18n="@@possessiveDietPlan">'s Diet Plan</span></span>
      } @else {
        <span class="tw-font-bold tw-text-300 tw-text-white tw-normal-case" i18n="@@dietPlanTitle">Diet Plan</span>
      }
    </div>
    <!-- Tabs only when the user has both FACE and HAIR regimens -->
    @if (availableTabs.length > 1) {
      <div class="tw-flex tw-w-full">
        @for (tab of availableTabs; track tab) {
          <div class="tw-flex-1 tw-text-center tw-py-3 tw-font-semibold tw-text-300 tw-border-b-[6px] tw-normal-case"
               [ngClass]="activeTab === tab ? 'tw-text-white tw-border-teal-500' : 'tw-text-gray-400 tw-border-transparent'"
               (click)="selectTab(tab)">
            @if (tab === Class.FACE) {
              <span i18n="@@dietTabFace">FACE</span>
            }
            @if (tab === Class.HAIR) {
              <span i18n="@@dietTabHair">HAIR</span>
            }
          </div>
        }
      </div>
    }
  </div>

  <!-- Body. Rendered (so the content images start fetching) but kept invisible behind the loader
       until those images settle, so the buy section doesn't flash in before the images. -->
  @if (!loading) {
    <div class="tw-flex-auto tw-overflow-x-hidden tw-overflow-y-auto tw-w-full" [ngClass]="imagesReady ? '' : 'tw-invisible'">
      <!-- "Your diet created by" dietician card (same for acne / non-acne / hair) -->
      <div class="tw-flex tw-items-center tw-justify-between tw-pl-8 tw-pr-[38px] tw-pt-[10px] tw-mb-[-2px]">
        <div class="tw-flex tw-flex-col tw-gap-[6px]">
          <div class="tw-flex tw-items-center tw-gap-1">
            <img class="tw-h-3 tw-w-3" [src]="createdByIconUrl" alt="" />
            <span class="tw-font-body tw-font-bold tw-text-[10px] tw-leading-[15px] tw-tracking-[0.4px] tw-uppercase tw-text-yellow-400" i18n="@@yourDietCreatedBy">Your Diet created by</span>
          </div>
          <div class="tw-flex tw-flex-col">
            <p class="tw-font-lexend tw-font-bold tw-text-[14px] tw-leading-[16.8px] tw-text-gray-800 tw-normal-case" i18n="@@dieticianName">Ramanjeet Kaur</p>
            <p class="tw-font-body tw-font-medium tw-text-[12px] tw-leading-[18px] tw-text-gray-500 tw-normal-case" i18n="@@nutritionistAndDietician">Nutritionist &amp; Dietician</p>
          </div>
        </div>
        <img class="tw-w-[92px] tw-h-[94px] tw-object-contain tw-shrink-0" [src]="dieticianImageUrl" alt="" />
      </div>

      <!-- Top content image. Only the active branch (acne / non-acne / hair) + active language image is
           mounted, so the other branches' assets are never fetched. Switching tabs lazy-loads the new one. -->
      <div class="tw-p-4 tw-pt-0">
        @if (topImageUrl; as topImage) {
          <img class="tw-w-full tw-h-auto" [src]="topImage" alt="" (load)="onContentImageSettled()" (error)="onContentImageSettled()" />
        }
      </div>

      <!-- Buy section -->
      <div class="tw-bg-[#e5f1ef] tw-px-4 tw-py-5">
        <h3 class="tw-font-bold tw-text-400 tw-text-black tw-capitalize tw-mb-4" i18n="@@getYourCustomisedDietPlan">Get your customised diet plan</h3>
        <div class="tw-flex tw-gap-[10px] tw-items-stretch">
          <!-- BASIC -->
          <div class="tw-flex-1 tw-bg-white tw-rounded-[9px] tw-px-2 tw-py-4 tw-flex tw-flex-col tw-gap-2 tw-shadow-[0px_2px_4px_0px_rgba(0,0,0,0.1)]"
               [ngClass]="selectedPlan === dietPlans.BASIC ? 'tw-border-[1.5px] tw-border-teal-600' : 'tw-border-[1.5px] tw-border-transparent'"
               (click)="selectPlan(dietPlans.BASIC)">
            <div class="tw-flex tw-gap-2 tw-items-start">
              <span class="tw-shrink-0 tw-h-6 tw-w-6 tw-rounded-full tw-border-2 tw-flex tw-items-center tw-justify-center"
                    [ngClass]="selectedPlan === dietPlans.BASIC ? 'tw-border-teal-600' : 'tw-border-gray-300'">
                @if (selectedPlan === dietPlans.BASIC) {
                  <span class="tw-h-3 tw-w-3 tw-rounded-full tw-bg-teal-600"></span>
                }
              </span>
              <p class="tw-font-bold tw-text-300 tw-text-[#222]"><span i18n="@@oneDietCall">1 Diet Call</span><br />₹{{ basicPrice }}</p>
            </div>
            <div class="tw-flex tw-flex-col tw-gap-2">
              <div class="tw-flex tw-gap-1 tw-items-center">
                <cs-icon class="tw-h-4 tw-w-4" [iconName]="'check'"></cs-icon>
                <span class="tw-text-200 tw-text-gray-600" i18n="@@oneConsultationCall">1 consultation call</span>
              </div>
              <div class="tw-flex tw-gap-1 tw-items-center">
                <cs-icon class="tw-h-4 tw-w-4" [iconName]="'check'"></cs-icon>
                <span class="tw-text-200 tw-text-gray-600" i18n="@@detailedMealPlanShort">Detailed meal plan</span>
              </div>
              <div class="tw-flex tw-gap-1 tw-items-center">
                <cs-icon class="tw-h-4 tw-w-4" [iconName]="'check'"></cs-icon>
                <span class="tw-text-200 tw-text-gray-600" i18n="@@guidanceCall">Guidance call</span>
              </div>
            </div>
          </div>
          <!-- PRO -->
          <div class="tw-flex-1 tw-bg-white tw-rounded-[9px] tw-px-2 tw-py-4 tw-flex tw-flex-col tw-gap-2 tw-shadow-[0px_2px_4px_0px_rgba(0,0,0,0.1)]"
               [ngClass]="selectedPlan === dietPlans.PRO ? 'tw-border-[1.5px] tw-border-teal-600' : 'tw-border-[1.5px] tw-border-transparent'"
               (click)="selectPlan(dietPlans.PRO)">
            <div class="tw-flex tw-gap-2 tw-items-start">
              <span class="tw-shrink-0 tw-h-6 tw-w-6 tw-rounded-full tw-border-2 tw-flex tw-items-center tw-justify-center"
                    [ngClass]="selectedPlan === dietPlans.PRO ? 'tw-border-teal-600' : 'tw-border-gray-300'">
                @if (selectedPlan === dietPlans.PRO) {
                  <span class="tw-h-3 tw-w-3 tw-rounded-full tw-bg-teal-600"></span>
                }
              </span>
              <p class="tw-font-bold tw-text-300 tw-text-[#222]"><span i18n="@@threeDietCall">3 Diet Call</span><br />₹{{ proPlanPrice }}</p>
            </div>
            <div class="tw-flex tw-flex-col tw-gap-2">
              <div class="tw-flex tw-gap-1 tw-items-center">
                <cs-icon class="tw-h-4 tw-w-4" [iconName]="'check'"></cs-icon>
                <span class="tw-text-200 tw-text-gray-600" i18n="@@oneConsultationCall">1 consultation call</span>
              </div>
              <div class="tw-flex tw-gap-1 tw-items-center">
                <cs-icon class="tw-h-4 tw-w-4" [iconName]="'check'"></cs-icon>
                <span class="tw-text-200 tw-text-gray-600" i18n="@@twoFreeProduct">2 free product</span>
              </div>
              <div class="tw-flex tw-gap-1 tw-items-center">
                <cs-icon class="tw-h-4 tw-w-4" [iconName]="'check'"></cs-icon>
                <span class="tw-text-200 tw-text-gray-600" i18n="@@detailedMealPlanShort">Detailed meal plan</span>
              </div>
              <div class="tw-flex tw-gap-1 tw-items-start">
                <cs-icon class="tw-h-4 tw-w-4 tw-shrink-0" [iconName]="'check'"></cs-icon>
                <span class="tw-text-200 tw-text-gray-600" i18n="@@threeMonthlyFollowupCalls">3 monthly follow-up calls</span>
              </div>
            </div>
          </div>
        </div>
        <button class="tw-mt-4 tw-w-full tw-h-10 tw-bg-teal-600 tw-text-white tw-font-semibold tw-text-400 tw-rounded-lg" (click)="buy()">
          <span i18n="@@bookNow">Book Now</span>
        </button>
      </div>

      <!-- Bottom content image. Only the active branch + active language image is mounted;
           switching tabs lazy-loads the new one. -->
      <div class="tw-bg-yellow-100 tw-p-4">
        @if (bottomImageUrl; as bottomImage) {
          <img class="tw-w-full tw-h-auto" [src]="bottomImage" alt="" (load)="onContentImageSettled()" (error)="onContentImageSettled()" />
        }
      </div>
    </div>
  }
</div>
